package com.martdev.flickq.room.model

data class Room(
    val id: Long = 0,
    val name: String = "N/A",
    val rows: Int = 0,
    val columns: Int = 0
)
